// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1pVdc","title":"ClientReferral_title__L4QO_","itemText":"ClientReferral_itemText__3_XW_"};